import styled from 'styled-components';

export const QuantityPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const QuantityPickerLabel = styled.h3`
  margin-top: 0%;
`;
